import { render, staticRenderFns } from "./SocialNetworkCreate.vue?vue&type=template&id=461e6def&"
import script from "./SocialNetworkCreate.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkCreate.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworkCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports